import axios from "axios";

const vbApiService = axios.create({
  baseURL: process.env.VB_API_URL,
  headers: {
    ...{
      Accept: "application/ld+json",
      "Content-Type": "application/ld+json",
    },
  },
});
export default vbApiService;
